import React from 'react';
import { Navigation } from './Navigation';
import { Toaster } from '../ui/sonner';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="max-w-7xl mx-auto px-6 lg:px-12 py-8 lg:py-12">
        {children}
      </main>
      <Toaster position="bottom-right" />
    </div>
  );
};

export default Layout;
